var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1772 13.5418L15.9866 13.8737L16.2573 14.1444L20.2573 18.1444C20.8355 18.7226 20.8286 19.666 20.2373 20.2573C19.6525 20.842 18.7291 20.842 18.1444 20.2573L14.1444 16.2573L13.8737 15.9866L13.5418 16.1772C11.596 17.2946 9.32205 17.9788 6.63786 17.1529C3.37717 16.1481 0.886863 13.2675 0.548316 9.90079L0.547991 9.89775C0.413414 8.63695 0.562742 7.36203 0.985027 6.16646C1.40731 4.97089 2.09184 3.885 2.98842 2.98842C3.885 2.09184 4.97089 1.40731 6.16646 0.985028C7.36203 0.562743 8.63695 0.413414 9.89774 0.547991L9.89774 0.548028L9.9038 0.5486C13.2855 0.86798 16.1473 3.37433 17.153 6.63805L17.1532 6.6388C17.9785 9.30238 17.2947 11.5958 16.1772 13.5418ZM3.51081 8.99082C3.51081 12.067 5.93467 14.4908 9.01081 14.4908C12.087 14.4908 14.5108 12.067 14.5108 8.99082C14.5108 5.91467 12.087 3.49082 9.01081 3.49082C5.93467 3.49082 3.51081 5.91467 3.51081 8.99082Z",
    fill: "#DCA11C",
    stroke: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.af552e42f96d37188036e05ad26becae.svg";
export { ForwardRef as ReactComponent };